import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { ActivatedRoute } from '@angular/router';
import { SelectedArea } from 'src/app/shared/area-select.component';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-camisa-trieur-card-II',
    templateUrl: './camisa-trieur-card-II.component.html'
})

export class CamisaTrieurCardIIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected route: ActivatedRoute, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Cálculos', false);
        if (this.areaSelect === SelectedArea.Comercial) {
            this.formulario = this.formBuilder.group({
                rendimento_r1m: [null, [Validators.required]],
                rendimento_r2: [null, [Validators.required]],
                rendimento_r3: [null, [Validators.required]],
                rendimento_c1m: [null, [Validators.required]],
                rendimento_c2: [null, [Validators.required]],
                rendimento_c3: [null, [Validators.required]],
                min_r1m: [null, [Validators.required]],
                min_r2: [null, [Validators.required]],
                min_r3: [null, [Validators.required]],
                min_c1m: [null, [Validators.required]],
                min_c2: [null, [Validators.required]],
                min_c3: [null, [Validators.required]],
                max_r1m: [null, [Validators.required]],
                max_r2: [null, [Validators.required]],
                max_r3: [null, [Validators.required]],
                max_c1m: [null, [Validators.required]],
                max_c2: [null, [Validators.required]],
                max_c3: [null, [Validators.required]],
                range_r1m: [null, [Validators.required]],
                range_r2: [null, [Validators.required]],
                range_r3: [null, [Validators.required]],
                range_c1m: [null, [Validators.required]],
                range_c2: [null, [Validators.required]],
                range_c3: [null, [Validators.required]],
                sdev_r1m: [null, [Validators.required]],
                sdev_r2: [null, [Validators.required]],
                sdev_r3: [null, [Validators.required]],
                sdev_c1m: [null, [Validators.required]],
                sdev_c2: [null, [Validators.required]],
                sdev_c3: [null, [Validators.required]],
                resultado_r1m: [null, [Validators.required]],
                resultado_r2: [null, [Validators.required]],
                resultado_r3: [null, [Validators.required]],
                resultado_c1m: [null, [Validators.required]],
                resultado_c2: [null, [Validators.required]],
                resultado_c3: [null, [Validators.required]]
            });

        }

    }


    public async ngOnInit(): Promise<void> {
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    public hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

}

